import { render, staticRenderFns } from "./innerPage.vue?vue&type=template&id=65b05ca4&scoped=true&"
import script from "./innerPage.vue?vue&type=script&lang=js&"
export * from "./innerPage.vue?vue&type=script&lang=js&"
import style0 from "./innerPage.vue?vue&type=style&index=0&id=65b05ca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b05ca4",
  null
  
)

export default component.exports